import React from "react";

export default class Download extends React.PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      fileTitle: [],
      fileName: [],
      description: null,
      group: null,
    };
  }

  componentWillReceiveProps(props) {
    let { product } = props;
    let { fileTitle, fileName, description, group } = this.state;
    let productName = product.name;
    this.props.dataApi.fetchDownloadData(
      function (response) {
        fileTitle = response[productName]["file_title"];
        fileName = response[productName]["file_name"];
        group = response[productName]["group"];
        if (response[productName].hasOwnProperty("description")) {
          description = response[productName]["description"];
        } else {
          description = null;
        }
        this.setState({ fileTitle, fileName, description, group });
      }.bind(this)
    );
  }

  componentDidMount() {
    let { product } = this.props;
    let { fileTitle, fileName, description, group } = this.state;
    let productName = product.name;
    this.props.dataApi.fetchDownloadData(
      function (response) {
        fileTitle = response[productName]["file_title"];
        fileName = response[productName]["file_name"];
        group = response[productName]["group"];
        if (response[productName].hasOwnProperty("description")) {
          description = response[productName]["description"];
        } else {
          description = null;
        }
        this.setState({ fileTitle, fileName, description, group });
      }.bind(this)
    );
  }

  render() {
    const { product, translationData } = this.props;
    let { fileTitle, fileName, description, group } = this.state;
    const imgSrc = "assets/images/company/" + product.logo;
    const pdfSrc = "assets/pdf/";
    let lastMinusThirdFileTitle = null;
    let lastMinusThirdFileName = null;

    if ("prolia" === product.name) {
      lastMinusThirdFileTitle = fileTitle[fileTitle.length - 3];
      lastMinusThirdFileName = fileName[fileName.length - 3];
    }

    let productArraySkipBoxes = ["avsola", "kanjinti", "mvasi", "riabni"];
    let skipBox = false;

    if (productArraySkipBoxes.includes(product.name)) {
      skipBox = true;
    }

    let lastBeforeFileTitle = fileTitle[fileTitle.length - 2];
    let lastBeforeFileName = fileName[fileName.length - 2];
    let lastFileTitle = fileTitle[fileTitle.length - 1];
    let lastFileName = fileName[fileName.length - 1];
    return (
      <div className="row">
        <div className="row-no-margin">
          <div className="selected-product-logo">
            <img src={imgSrc} className="img-responsive" alt="" />
          </div>
          {((group) => {
            switch (group) {
              default:
              case 0:
                return (
                  <div>
                    <div id={product.name} className="download-content">
                      {fileTitle.map(function (item, index) {
                        return (
                          <a
                            key={index}
                            className="download-link"
                            rel="noopener noreferrer"
                            href={pdfSrc + fileName[index]}
                            target="_blank"
                          >
                            {item}
                          </a>
                        );
                      })}
                    </div>
                    <div className="col-md-8 col-md-offset-2">
                      <div className="download-description">
                        <p>{translationData.downloadBottom}</p>
                      </div>
                    </div>
                  </div>
                );
              case 1:
                return (
                  <div className="download-content row-eq-height" style={{justifyContent: 'center' }}>
                    {!skipBox && (
                      <>
                        <div className="col-md-4 download-step">
                          <p className="step-title">
                            {translationData.download.step1}
                          </p>
                          <p
                            className="step-comment"
                            dangerouslySetInnerHTML={{ __html: description }}
                          />
                        </div>
                        <div className="col-md-4 download-step">
                          <p className="step-title">
                            {translationData.download.step2}
                          </p>
                          <p
                            className="step-comment"
                            dangerouslySetInnerHTML={{
                              __html:
                                translationData.download.step2_description,
                            }}
                          />
                        </div>
                      </>
                    )}
                    <div className="col-md-4 download-step">
                      <p className="step-title">
                        {translationData.download.step3}
                      </p>
                      {null !== lastMinusThirdFileTitle ? (
                        <a
                          className="download-link"
                          rel="noopener noreferrer"
                          href={pdfSrc + lastMinusThirdFileName}
                          target="_blank"
                        >
                          {lastMinusThirdFileTitle}
                        </a>
                      ) : null}
                      <a
                        className="download-link"
                        rel="noopener noreferrer"
                        href={pdfSrc + lastBeforeFileName}
                        target="_blank"
                      >
                        {lastBeforeFileTitle}
                      </a>
                      <a
                        className="download-link"
                        rel="noopener noreferrer"
                        href={pdfSrc + lastFileName}
                        target="_blank"
                      >
                        {lastFileTitle}
                      </a>
                    </div>
                  </div>
                );
              case 2:
                return (
                  <div className="col-md-8 col-md-offset-2">
                    <div className="non-download-description">
                      <h1 dangerouslySetInnerHTML={{ __html: description }} />
                    </div>
                  </div>
                );
              case 3:
                return (
                  <div>
                    <div id={product.name} className="download-content mb-0">
                      {fileTitle.map(function (item, index) {
                        return (
                          <a
                            key={index}
                            className="download-link"
                            rel="noopener noreferrer"
                            href={pdfSrc + fileName[index]}
                            target="_blank"
                          >
                            {item}
                          </a>
                        );
                      })}
                    </div>
                    <div className="col-md-8 col-md-offset-2">
                      <div className="non-download-description">
                        <h1 dangerouslySetInnerHTML={{ __html: description }} />
                      </div>
                    </div>
                  </div>
                );
              case 10:
                return (
                  <div className="download-content row-eq-height" style={{justifyContent: 'center' }}>
                    {!skipBox && (
                      <>
                        <div className="col-md-4 download-step">
                          <p className="step-title">
                            {translationData.download.step1}
                          </p>
                          <p
                            className="step-comment"
                            dangerouslySetInnerHTML={{ __html: description }}
                          />
                        </div>
                        <div className="col-md-4 download-step">
                          <p className="step-title">
                            {translationData.download.step2}
                          </p>
                          <p
                            className="step-comment"
                            dangerouslySetInnerHTML={{
                              __html:
                                translationData.download.step2_tavneos,
                            }}
                          />
                        </div>
                      </>
                    )}
                    <div className="col-md-4 download-step">
                      <p className="step-title">
                        {translationData.download.step3}
                      </p>
                      {null !== lastMinusThirdFileTitle ? (
                        <a
                          className="download-link"
                          rel="noopener noreferrer"
                          href={pdfSrc + lastMinusThirdFileName}
                          target="_blank"
                        >
                          {lastMinusThirdFileTitle}
                        </a>
                      ) : null}
                      <a
                        className="download-link"
                        rel="noopener noreferrer"
                        href={pdfSrc + lastBeforeFileName}
                        target="_blank"
                      >
                        {lastBeforeFileTitle}
                      </a>
                      <a
                        className="download-link"
                        rel="noopener noreferrer"
                        href={pdfSrc + lastFileName}
                        target="_blank"
                      >
                        {lastFileTitle}
                      </a>
                    </div>
                  </div>
                );
            }
          })(group)}
        </div>
      </div>
    );
  }
}
